import axios from "axios";
import { rootStore } from "@/mobx/store";
import { API_URL, API_URL_DEV, API_URL_LOCAL, HEADER, RESULT_CODE } from "@/config/const";

let apiUrl = `${API_URL}`;
const currentUrl = window.location.href;

if (currentUrl.includes('dev.chewingpay.com')) {
  apiUrl = `${API_URL_DEV}`;
} else if (currentUrl.includes('chewingpay.com')) {
  apiUrl = `${API_URL}`;
} else if (currentUrl.includes('localhost')) {
  apiUrl = `${API_URL_LOCAL}`;
}

// axios 인스턴스 생성
const api = axios.create({
  baseURL: apiUrl,
  headers: {
    [HEADER.LANG]: "ko", // 언어 설정
  },
});

// 요청 전: 토큰 헤더에 추가
api.interceptors.request.use((config) => {
  const token = rootStore.token; // observable로 직접 추적
  if (token) {
    config.headers[HEADER.AUTH_TOKEN] = token;
  }
  return config;
});

// 응답 처리: 토큰 만료 시 재발급
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    // 토큰 만료 시 재요청 로직
    if (
      err.response?.data?.result_code === RESULT_CODE.TOKEN_EXPIRED &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refresh_token");
        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        const { data } = await axios.post(`${apiUrl}/auth/refresh`, {
          refreshToken,
        });

        if (data.result_code === RESULT_CODE.SUCCESS) {
          const newToken = data.result_data.accessToken;
          rootStore.setToken(newToken);
          originalRequest.headers[HEADER.AUTH_TOKEN] = newToken;
          return api(originalRequest);
        } else {
          throw new Error("Token refresh failed");
        }
      } catch (e) {
        // refresh 실패 시 로그아웃 처리
        rootStore.signOut();
        window.location.href = "/login";
        return Promise.reject(e);
      }
    }

    // 인증 관련 에러 처리
    if (
      err.response?.data?.result_code === RESULT_CODE.EMPTY_TOKEN ||
      err.response?.data?.result_code === RESULT_CODE.TOKEN_EXPIRED
    ) {
      rootStore.signOut();
      window.location.href = "/login";
      return Promise.reject(err);
    }

    return Promise.reject(err);
  }
);

export default api;
